module.exports = __webpack_public_path__ + "static/media/deportes-icon--white.c2bc9796.svg";